import { ELeadStage, LEAD_STAGES } from 'src/services/api/leads/types';

export const LEAD_STAGE_LABELS: Record<ELeadStage, string> = {
    [ELeadStage.NEW]: 'New',
    [ELeadStage.CONTACTED]: 'Contacted',
    [ELeadStage.TOUR_REQUESTED]: 'Tour Requested',
    [ELeadStage.TOUR_SCHEDULED]: 'Tour Scheduled',
    [ELeadStage.TOUR_COMPLETED]: 'Tour Completed',
    [ELeadStage.INVITED_TO_APPLY]: 'Invited to Apply',
    [ELeadStage.APPLICATION_COMPLETED]: 'Application Completed',
    [ELeadStage.APPLICATION_APPROVED]: 'Application Approved',
    [ELeadStage.LEASE_SIGNED]: 'Lease Signed',
    [ELeadStage.NOT_INTERESTED]: 'Not Interested',
    [ELeadStage.NOT_QUALIFIED]: 'Not Qualified',
};

export const leadStageOptions = LEAD_STAGES.map((stage) => ({
    value: stage,
    label: LEAD_STAGE_LABELS[stage],
}));
